<div class="page m-auto width"  (click)="backPress()">
   
<h1 class="fontSize" (click)="backPress" >{{customTitle}}</h1>

</div>  

